import { getData } from "RestControllers/Controller";
import axios from 'axios';

// Asegurar que la URL base siempre termine con /
const API_BASE = process.env.REACT_APP_BASE_URL?.endsWith('/') 
  ? process.env.REACT_APP_BASE_URL 
  : `${process.env.REACT_APP_BASE_URL}/`;

const BASE_URL = `${API_BASE}api/studio/payments/`;
const STUDIO_BASE_URL = `${API_BASE}api/studio/`;

// Helper function para llamadas GET con URL completa (sin params adicionales)
const getDataWithFullUrl = async (url, headers = {}) => {
  const token = localStorage.getItem("access");
  const finalHeaders = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...headers
  };
  return axios.get(url, { headers: finalHeaders });
};

// Obtener todos los pagos
export const getAllPayments = async (sedeParams = {}, sedeHeaders = {}) => {
  const response = await getData("GET", BASE_URL, sedeParams, {}, sedeHeaders);
  return response.data;
};

// Get comprehensive closing summary (daily + weekly)
export const getComprehensiveClosureSummary = async (params = {}, sedeParams = {}, sedeHeaders = {}) => {
  let url = `${STUDIO_BASE_URL}cierres-completos/`;
  const queryParams = new URLSearchParams();
  
  if (params.date) {
    queryParams.append('date', params.date);
  } else if (params.start_date && params.end_date) {
    queryParams.append('start_date', params.start_date);
    queryParams.append('end_date', params.end_date);
  } else if (params.month) {
    queryParams.append('month', params.month);
  } else if (params.year) {
    queryParams.append('year', params.year);
  }
  
  // Add sede params
  Object.entries(sedeParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      queryParams.append(key, value);
    }
  });
  
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`;
  }
  
  const response = await getDataWithFullUrl(url, sedeHeaders);
  return response.data;
};

// Get daily closing summary
export const getDailyClosureSummary = async (params = {}, sedeParams = {}, sedeHeaders = {}) => {
  let url = `${STUDIO_BASE_URL}cierres-diarios/`;
  const queryParams = new URLSearchParams();
  
  if (params.date) {
    queryParams.append('date', params.date);
  } else if (params.start_date && params.end_date) {
    queryParams.append('start_date', params.start_date);
    queryParams.append('end_date', params.end_date);
  }
  
  // Add sede params
  Object.entries(sedeParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      queryParams.append(key, value);
    }
  });
  
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`;
  }
  
  const response = await getDataWithFullUrl(url, sedeHeaders);
  return response.data;
};

// Get weekly closing summary
export const getWeeklyClosureSummary = async (params = {}, sedeParams = {}, sedeHeaders = {}) => {
  let url = `${STUDIO_BASE_URL}cierres-semanales/`;
  const queryParams = new URLSearchParams();
  
  if (params.year) {
    queryParams.append('year', params.year);
  } else if (params.month) {
    queryParams.append('month', params.month);
  }
  
  // Add sede params
  Object.entries(sedeParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      queryParams.append(key, value);
    }
  });
  
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`;
  }
  
  const response = await getDataWithFullUrl(url, sedeHeaders);
  return response.data;
};

// Legacy function for backward compatibility
export const getFullClosureSummary = async (mes, sedeParams = {}, sedeHeaders = {}) => {
  if (mes && mes !== "all") {
    return getComprehensiveClosureSummary({ month: mes }, sedeParams, sedeHeaders);
  } else {
    return getComprehensiveClosureSummary({}, sedeParams, sedeHeaders);
  }
};

// Si necesitas mantener getPaymentsByMonth o similares, los dejas aquí
export const getFullSummaryByMonth = async (mes, sedeParams = {}, sedeHeaders = {}) => {
  const queryParams = new URLSearchParams({ month: mes });
  
  Object.entries(sedeParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      queryParams.append(key, value);
    }
  });
  
  const url = `${BASE_URL}closure-full-summary/?${queryParams.toString()}`;
  const response = await getDataWithFullUrl(url, sedeHeaders);
  return response.data;
};

export const getPaymentsByMonth = async (mes, sedeParams = {}, sedeHeaders = {}) => {
  const response = await getData("GET", `${BASE_URL}?month=${mes}`, sedeParams, {}, sedeHeaders);
  return response.data;
};

export const getPaymentsByDate = async (dia, sedeParams = {}, sedeHeaders = {}) => {
  const response = await getData("GET", `${BASE_URL}?date=${dia}`, sedeParams, {}, sedeHeaders);
  return response.data;
};

// Enhanced filtering function - CORRECCIÓN FINAL
export const getPaymentsWithFilters = async (filters = {}, headers = {}) => {
  const queryParams = new URLSearchParams();
  
  // Add all non-empty filters to query params
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      queryParams.append(key, value);
    }
  });
  
  // Construir URL completa con query string
  const url = queryParams.toString() 
    ? `${BASE_URL}?${queryParams.toString()}` 
    : BASE_URL;
  
  console.log('URL final a llamar:', url); // Temporal para debug
  console.log('Headers:', headers); // Ver qué headers se envían
  
  // Usar la función helper que NO pasa params adicionales a axios
  const response = await getDataWithFullUrl(url, headers);
  return response.data;
};

// Obtener pagos por cliente
export const getPaymentsByClient = async (clientId, sedeParams = {}, sedeHeaders = {}) => {
  const response = await getData("GET", BASE_URL + `?client=${clientId}`, sedeParams, {}, sedeHeaders);
  return response.data;
};

// Crear un nuevo pago
export const createPayment = async (payload, sedeParams = {}, sedeHeaders = {}) => {
  const response = await getData("POST", BASE_URL, sedeParams, payload, sedeHeaders);
  return response.data;
};

// Actualizar un pago existente
export const updatePayment = async (id, payload) => {
  const response = await getData("PUT", BASE_URL + `${id}/`, {}, payload);
  return response.data;
};

// Eliminar un pago
export const deletePayment = async (id) => {
  const response = await getData("DELETE", BASE_URL + `${id}/`);
  return response.data;
};

// Obtener clientes en periodo de gracia
export const getClientesEnGracia = async (sedeParams = {}, sedeHeaders = {}) => {
  const response = await getData("GET", BASE_URL + "en-gracia/", sedeParams, {}, sedeHeaders);
  return response.data;
};

// Extender vigencia de un pago específico
export const extendVigencia = async (id) => {
  const response = await getData("PUT", BASE_URL + `${id}/extend-vigencia/`);
  return response.data;
};

// Enviar reporte de membresías vencidas al correo indicado
export const sendExpiredMembershipReport = async (email) => {
  const response = await getData("POST", BASE_URL + "send-expired-report/", {}, { email });
  return response.data;
};

// Renovar membresía vencida (crea nuevo pago con parámetros personalizados)
export const renewExpiredMembership = async (id, paymentMethod = "Manual", sedeParams = {}, sedeHeaders = {}, customData = {}) => {
  if (!id) {
    throw new Error("El ID del pago es requerido");
  }
  
  const payload = {
    payment_method: paymentMethod,
    ...customData // Incluir membership_id, valid_from, valid_until si se proporcionan
  };
  
  const url = BASE_URL + `${id}/renew-expired/`;
  console.log('Llamando a:', url, 'con payload:', payload);
  
  const response = await getData("POST", url, sedeParams, payload, sedeHeaders);
  return response.data;
};